<div data-testid="step-1-2-project-chart">
  <app-step-dot-menu
    [projectId]="projectId"
    testId="step1-1-dot-menu-button"
    [preselectedRole]="contributorRole"
    [preselectedAccessiblePages]="[projectChartaStep]"
  ></app-step-dot-menu>
  <p-tabs
    appTabsUnsavedReveal
    [value]="activeTabIndex()"
    data-testid="project-chart-tabs"
    (valueChange)="onTabChange($event!)"
    scrollable
  >
    <p-tablist data-testid="project-chart-tablist">
      <p-tab [value]="0" [appTabStatus]="overviewTabStatus.signal()" data-testid="overview-tab">
        {{ 'project.steps.projectChartTab1' | transloco }}
      </p-tab>
      <p-tab [value]="1" [appTabStatus]="scopeTabStatus.signal()" data-testid="scope-tab">
        {{ 'project.steps.projectChartTab2' | transloco }}
      </p-tab>
      <p-tab [value]="2" [appTabStatus]="parametersTabStatus.signal()" data-testid="parameters-tab">
        {{ 'project.steps.projectChartTab3' | transloco }}
      </p-tab>
      <p-tab
        [value]="3"
        [appTabStatus]="rolesAndStakeholdersTabStatus.signal()"
        data-testid="roles-and-stakeholders-tab"
      >
        {{ 'project.steps.projectChartTab4' | transloco }}
      </p-tab>
      <p-tab [value]="4" [appTabStatus]="timeFrameTabStatus.signal()" data-testid="time-frame-tab">
        {{ 'project.steps.projectChartTab5' | transloco }}
      </p-tab>
    </p-tablist>
    <p-tabpanels class="mt-6" data-testid="project-chart-tabpanels">
      <p-card data-testid="project-chart-card">
        <p-tabpanel [value]="0" data-testid="overview-tabpanel">
          @if (loadedTabs().has(0)) {
            <app-step-1-2-project-chart-overview
              [preloadedData]="overviewData()"
              (statusChange)="onOverviewStatusChange($event)"
            >
            </app-step-1-2-project-chart-overview>
          }
        </p-tabpanel>
        <p-tabpanel [value]="1" data-testid="scope-tabpanel">
          @if (loadedTabs().has(1)) {
            <app-step-1-2-project-chart-scope
              [preloadedData]="scopeData()"
              (statusChange)="onScopeStatusChange($event)"
            >
            </app-step-1-2-project-chart-scope>
          }
        </p-tabpanel>
        <p-tabpanel [value]="2" data-testid="parameters-tabpanel">
          @if (loadedTabs().has(2)) {
            <app-step-1-2-project-charter-parameters
              [preloadedData]="parametersData()"
              (statusChange)="onParametersStatusChange($event)"
            >
            </app-step-1-2-project-charter-parameters>
          }
        </p-tabpanel>
        <p-tabpanel [value]="3" data-testid="roles-and-stakeholders-tabpanel">
          @if (loadedTabs().has(3)) {
            <app-step-1-2-project-charter-roles-and-stakeholders
              [preloadedData]="rolesAndStakeholdersData()"
              (statusChange)="onRolesAndStakeholdersStatusChange($event)"
            >
            </app-step-1-2-project-charter-roles-and-stakeholders>
          }
        </p-tabpanel>
        <p-tabpanel [value]="4" data-testid="time-frame-tabpanel">
          @if (loadedTabs().has(4)) {
            <app-step-1-2-project-charter-time-frame
              (statusChange)="onTimeFrameStatusChange($event)"
            ></app-step-1-2-project-charter-time-frame>
          }
        </p-tabpanel>
      </p-card>
    </p-tabpanels>
  </p-tabs>
</div>
